import { ICarbonCausalChain } from './carbon-causal-chain';
import { IGlobalExternality } from './global-externality';
import { IResource } from './resource';
import { IStock } from './stock';
import { ITransitionElement } from './transition-element';
import { IVariable } from './variable';

export interface ClimateCortexModel_v3 {
  carbonCausalChainDefinitions: ICarbonCausalChain[];
  resourceDefinitions: IResource[];
  stockDefinitions: IStock[];
  transitionElementDefinitions: ITransitionElement[];
  globalExternalityDefinitions: IGlobalExternality[];
  variableDefinitions: IVariable[];
}

export enum EconomicStockImpactType {
  None = 'NONE',
  Full = 'FULL',
}
